import { render, staticRenderFns } from "./Prototyping.vue?vue&type=template&id=71ed87fc"
import script from "./Prototyping.vue?vue&type=script&lang=ts"
export * from "./Prototyping.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports